import React, { useState, useEffect } from "react";

// Export the supportedJobs array so it can be imported by other components
export const supportedJobs = [
'Accountant',
'Account Executive',
'Accounting Clerk',
'Accounts Payable Specialist',
'Accounts Receivable Specialist',
'Administrative Assistant',
'AI Engineer',
'Android Developer',
'Architect',
'Assembler',
'Assistant',
'Assistant Administrative',
'Assistant Manager',
'Assistant Store Manager',
'Attorney',
'Auto Mechanic',
'Automotive Technician',
'Banker',
'Barista',
'Bartender',
'Bookkeeper',
'Branch Manager',
'Business Analyst',
'Business Development Manager',
'Business Manager',
'Call Center Representative',
'Car Sales',
'Caregiver',
'Carpenter',
'Cashier',
'CDL Driver',
'Certified Medical Assistant',
'Certified Nursing Assistant',
'CFO',
'Chef',
'Chemist',
'Civil Engineer',
'Cleaner',
'Clerk',
'CNC Machinist',
'CNC Operator',
'CNC Programmer',
'Construction Manager',
'Construction Superintendent',
'Construction Worker',
'Consultant',
'Controller',
'Cook',
'Cosmetologist',
'Counselor',
'CPA',
'Customer Service',
'Customer Service Representative',
'Data Analyst',
'Data Engineer',
'Data Entry Clerk',
'Data Scientist',
'Delivery Driver',
'Dental Assistant',
'Dental Hygienist',
'Dental Receptionist',
'Dentist',
'Designer',
'DevOps Engineer',
'Diesel Mechanic',
'Digital Marketing Specialist',
'Director, Marketing',
'Director of Nursing',
'Director, Sales',
'Director, UX',
'Dishwasher',
'Dispatcher',
'District Manager',
'Editor',
'Electrical Engineer',
'Electrician',
'Embedded Software Engineer',
'Environmental Officer',
'Esthetician',
'Estimator',
'Executive',
'Executive Assistant',
'Executive Chef',
'Finance Manager',
'Financial Advisor',
'Financial Analyst',
'Forklift Operator',
'Front Desk Receptionist',
'Front End Developer',
'General Laborer',
'General Manager',
'Graphic Design',
'Hadoop Developer',
'Hair Stylist',
'Help Desk Associate',
'Heavy Equipment Operator',
'Hostess',
'Hotel Manager',
'Housekeeper',
'HVAC Installer',
'HVAC Service Technician',
'HVAC Technician',
'HR Manager',
'HR Specialist',
'Inside Sales',
'Insurance Agent',
'Insurance Sales',
'Interior Designer',
'Intern',
'IOS Developer',
'IT',
'IT Project Manager',
'Java Developer',
'Kitchen Manager',
'Lab Technician',
'Landscape Worker',
'Law Enforcement Officer',
'Leasing Consultant',
'Legal Assistant',
'Legal Secretary',
'Licensed Practical Nurse',
'Linux Administrator',
'Loan Officer',
'Logistics Specialist',
'Machine Operator',
'Maintenance Manager',
'Maintenance Supervisor',
'Manager',
'Marketing',
'Marketing Coordinator',
'Marketing Manager',
'Massage Therapist',
'Material Handler',
'Mechanical Engineer',
'Medical Assistant',
'Medical Billing Specialist',
'Medical Receptionist',
'ML Engineer',
'Nanny',
'Nurse Practitioner',
'Nursing Assistant',
'Occupational Therapist',
'Office Administrator',
'Office Assistant',
'Office Clerk',
'Office Manager',
'Operating Nurse',
'Operations Analyst',
'Operations Associate',
'Operations Manager',
'Operations Supervisor',
'Outreach Coordinator',
'Outside Sales Rep',
'Package Handler',
'Packer',
'Painter',
'Paralegal',
'Parking Attendant',
'Patient Access Manager',
'Patient Assistant',
'Patient Service Representative',
'Payroll Specialist',
'Personal Assistant',
'Pest Control Technician',
'Pet Sitter',
'Pharmacist',
'Pharmacy Technician',
'Phlebotomist',
'Photographer',
'Physical Therapist Assistant',
'Physician',
'Physician Assistant',
'Police Officer',
'Porter',
'Prep Cook',
'Process Engineer',
'Producer',
'Product Engineer',
'Product Manager',
'Production Assistant',
'Production Associate',
'Production Manager',
'Production Operator',
'Production Supervisor',
'Production Worker',
'Program Analyst',
'Program Assistant',
'Program Coordinator',
'Program Director',
'Program Manager',
'Program Specialist',
'Project Manager',
'Project Coordinator',
'Property Manager',
'Public Safety Officer',
'Quality Assurance Analyst',
'Quality Assurance Engineer',
'Quality Assurance Inspector',
'Quality Assurance Manager',
'Quality Control Manager',
'Real Estate Agent',
'Real Estate Manager',
'Receptionist',
'Recruiter',
'Recruitment Manager',
'Regional Director',
'Regional Manager',
'Regional Sales Manager',
'Registered Nurse',
'Relationship Manager',
'Repair Technician',
'Research Assistant',
'Research Associate',
'Resident Assistant',
'Restaurant Manager',
'Retail Assistant Manager',
'Retail Associate',
'Retail Manager',
'Retail Merchandiser',
'Risk Manager',
'Room Attendant',
'Route Sales Representative',
'Rural Carrier Associate',
'Safety Manager',
'Safety Specialist',
'Sales and Marketing Manager',
'Sales Associate',
'Sales Consultant',
'Sales Director',
'Sales Manager',
'Sales Representative',
'Sales Specialist',
'Sales Support Representative',
'Sanitation Worker',
'Scheduling Coordinator',
'School Teacher',
'Seasonal Associate',
'Security Guard',
'Security Officer',
'Security Specialist',
'Service Advisor',
'Service Assistant',
'Service Coordinator',
'Service Manager',
'Service Technician',
'Services Director',
'Shift Leader',
'Shift Manager',
'Shipping and Receiving Clerk',
'Shuttle Driver',
'Site Manager',
'Social Media Intern',
'Social Media Specialist',
'Social Worker',
'Software Architect',
'Software Developer',
'Software Engineer',
'Special Education Teacher',
'Special Events Manager',
'Speech Language Pathologist',
'Sterile Processing Technician',
'Stock Associate',
'Stocker',
'Store Clerk',
'Student Assistant',
'Substance Abuse Counselor',
'Substitute Teacher',
'Superintendent',
'Supply Chain Manager',
'Support Specialist',
'Surgical Nurse',
'Surgical Technician',
'System Engineer',
'Systems Administrator',
'Systems Analyst',
'Teacher',
'Teaching Assistant',
'Team Manager',
'Team Member',
'Technical Program Manager',
'Technical Writer',
'Technician',
'Technologist',
'Telemarketing',
'Teller',
'Territory Manager',
'Therapist',
'Trainer',
'Training Manager',
'Training Specialist',
'Transporter',
'Truck Driver',
'Tutor',
'Unloader',
'Utility Worker',
'UX Designer',
'UX Researcher',
'Van Driver',
'Veterinary Assistant',
'Veterinary Receptionist',
'Veterinary Technician',
'Vice President',
'Warehouse Clerk',
'Warehouse Delivery Driver',
'Warehouse Supervisor',
'Warehouse Worker',
'Welder',
'X-Ray Technician',
'Web Designer',
'Delivery Manager',
'Research Engineer',
'Salesforce Developer',
'Trader',
'CAD Engineer',
'Mechanical Design Engineer',
'Manufacturing Engineer',
]

export default supportedJobs;
